import { ConstraintSpec } from './constraint-spec'
import { ConstraintConf } from '../../../shopfloor/workcenters/capability/constraints/constraint-conf'

export class ConstraintUtils {
  public static update(source: ConstraintSpec, target: ConstraintSpec): void {
    target.id = source.id
    target.propertyId = source.propertyId
    target.property = source.property
    target.description = source.description
    target.inputRequired = source.inputRequired
    target.operator = source.operator
    target.matchIfMissingProp = source.matchIfMissingProp
    target.singleSelection = source.singleSelection
  }

  public static updateConf(source: ConstraintConf, target: ConstraintConf): void {
    target.constraintSpecId = source.constraintSpecId
    target.values = source.values
  }
}
